import style from './topbar.module.scss';
import { useNavigate } from 'react-router-dom';
import { LangData } from '../../utils/LangData';
import { useSelector } from 'react-redux';

const TopBar = ({ type, text, logOut, link }) => {
  const navigate = useNavigate();
  const currentLang = useSelector(state => state.settings.setting.lang);
  return (
    <div className={style.topBar}>
      <div className={style.wrapper}>
        {type ? (
          <ul>
            <li
              style={{
                width: logOut ? '100%' : 'auto',
              }}
            >
              <a href={link ? link : '/cart?section=product'}>
                {text ? text : LangData[currentLang].component.breadCrumb.cart}
              </a>
              {logOut ? (
                <button
                  onClick={() => {
                    localStorage.removeItem('token');
                    navigate('/login');
                  }}
                >
                  {LangData[currentLang].component.breadCrumb.signOut}
                </button>
              ) : null}
            </li>
            {text ? null : <span>/</span>}
            {type === 'address' || type === 'payment' ? (
              <>
                <li>
                  <a href="/cart?section=address">
                    {LangData[currentLang].component.breadCrumb.customerInfo}
                  </a>
                </li>
                <span>/</span>
              </>
            ) : null}

            {type === 'payment' && (
              <>
                <li>
                  {LangData[currentLang].component.breadCrumb.paymentSelection}
                </li>
              </>
            )}
          </ul>
        ) : (
          <ul>
            <li>{LangData[currentLang].component.breadCrumb.parfum}</li>
            <span>/</span>
            <li>DIAMOND COLLECTION</li>
            <span>/</span>
            <li>SHADES OF GREY</li>
          </ul>
        )}
      </div>
    </div>
  );
};

export default TopBar;
